/**
 * Map a speed value (km/h) to a CSS color string.
 * Green (0-50) → Yellow (50-90) → Red (90+)
 */
export function speedToColor(speedKmh: number): string {
  if (speedKmh < 50) {
    // Green to Yellow: interpolate between #22c55e and #eab308
    const ratio = speedKmh / 50;
    return interpolateColor('#22c55e', '#eab308', ratio);
  } else if (speedKmh < 90) {
    // Yellow to Red: interpolate between #eab308 and #ef4444
    const ratio = (speedKmh - 50) / 40;
    return interpolateColor('#eab308', '#ef4444', ratio);
  } else {
    return '#ef4444';
  }
}

/**
 * Returns a Tailwind-compatible color class based on speed.
 */
export function speedToTailwindColor(speedKmh: number): string {
  if (speedKmh < 50) return 'text-green-500';
  if (speedKmh < 90) return 'text-yellow-500';
  return 'text-red-500';
}

/**
 * Returns the speed category label in Portuguese.
 */
export function speedCategory(speedKmh: number): string {
  if (speedKmh < 50) return 'Normal';
  if (speedKmh < 90) return 'Moderada';
  return 'Alta';
}

function interpolateColor(hex1: string, hex2: string, ratio: number): string {
  const r1 = parseInt(hex1.slice(1, 3), 16);
  const g1 = parseInt(hex1.slice(3, 5), 16);
  const b1 = parseInt(hex1.slice(5, 7), 16);
  const r2 = parseInt(hex2.slice(1, 3), 16);
  const g2 = parseInt(hex2.slice(3, 5), 16);
  const b2 = parseInt(hex2.slice(5, 7), 16);

  const r = Math.round(r1 + (r2 - r1) * ratio);
  const g = Math.round(g1 + (g2 - g1) * ratio);
  const b = Math.round(b1 + (b2 - b1) * ratio);

  return `rgb(${r}, ${g}, ${b})`;
}
